import { useEffect } from 'react'

export const useLiquidSkeleton = (selector: string): void => {
  useEffect(() => {
    const element = document.querySelector<HTMLElement>(selector)

    if (element) {
      element.classList.add('react-loaded')
    }

    return () => {
      if (element) {
        element.classList.remove('react-loaded')
      }
    }
  }, [selector])
}
